import { useTranslation } from 'react-i18next'

import { EntryControl } from './EntryControl'
import { useAcademicAdmissionForm } from './useAcademicAdmissionForm'

import { FormNavigation } from '@/components/form-controls'
import { FormsGroupsProps } from '@/types/forms/'

export const AcademicAdmissionForm = ({
    onNext,
    onPrevious,
    isReadOnly = false,
    onBlockedFieldClick
}: FormsGroupsProps): React.ReactElement => {
    const { t } = useTranslation()

    const {
        control,
        handleSubmit,
        watch,
        setValue,
        onSubmit,
        progress,
        isPreloading,
        hasPreloadData,
        preloadData,
        hasExistingData,
        hasLoadedExistingData,
        idAspirant,
        preloadedProgram
    } = useAcademicAdmissionForm({ onNext })

    return (
        <div className={`relative ${isReadOnly ? 'opacity-60' : ''}`}>
            {isReadOnly && (
                <>
                    <div className="absolute inset-0 z-10 bg-gray-200 bg-opacity-50 cursor-not-allowed" />
                    <div
                        className="absolute inset-0 z-20 bg-transparent cursor-pointer"
                        onClick={onBlockedFieldClick}
                    />
                    <div className="absolute top-2 right-2 z-30 bg-yellow-100 border border-yellow-400 text-yellow-800 px-2 py-1 rounded text-xs">
                        🔒 Campos bloqueados - Click para más información
                    </div>
                </>
            )}
            <form
                onSubmit={handleSubmit(onSubmit)}
                className="w-full space-y-4"
            >
                {/* Mostrar indicador de precarga si está activa */}
                {isPreloading && (
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                        <p className="text-blue-800 text-sm">
                            🔄 Precargando datos del programa seleccionado...
                        </p>
                    </div>
                )}

                {hasPreloadData &&
                    preloadData &&
                    !isPreloading &&
                    !hasExistingData &&
                    hasLoadedExistingData && (
                        <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
                            <p className="text-green-800 text-sm">
                                ✅ Datos del programa precargados
                                automáticamente
                            </p>
                            <p className="text-green-700 text-xs mt-1">
                                ¡Recuerda que puedes revisar la oferta académica
                                que tenemos disponible!
                            </p>
                        </div>
                    )}

                <EntryControl
                    control={control}
                    watchProgram={watch('program')}
                    watchAdmissionType={watch('admissionType')}
                    watchJornada={watch('studyModality')}
                    watchCampus={watch('campus')}
                    watchStartPeriod={watch('startPeriod')}
                    watchEducationModality={watch('educationModality')}
                    setValue={setValue}
                    idAspirant={idAspirant}
                    preloadedProgram={preloadedProgram}
                />

                <FormNavigation
                    onSubmit={handleSubmit(onSubmit)}
                    onPrevious={onPrevious}
                    progress={progress}
                    previousLabel={t('forms.ui.previous')}
                    submitLabel={t('forms.ui.nextPage')}
                />
            </form>
        </div>
    )
}
